import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

function Provider() {
  const [ProviderForm, setProviderForm] = useState({
    name: "",
    plan: "",
    operatorfind: "",
    api_id: "",
    type: "",
    status: "active",
    min_amount: "",
    max_amount: ""
  });

  const [apis, setApis] = useState([]);
  const [Providers, setProviders] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchProviders = async () => {
    try {
      // const res = await fetch("http://127.0.0.1:6060/api/v1/provider/list", {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   },
      // });
      const res = await authFetch("/api/v1/provider/list");
      if (!res.ok) throw new Error("Failed to fetch providers");

      const data = await res.json();
      if (Array.isArray(data)) setProviders(data);
      else setProviders([]);
    } catch (err) {
      showToast("Failed to fetch Providers", "error");
    }
  };

  const fetchApis = async () => {
    try {
      // const res = await fetch("http://127.0.0.1:6060/api/v1/api/list", {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   },
      // });
      const res = await authFetch("/api/v1/api/list");
      if (!res.ok) throw new Error("Failed to fetch APIs");

      const data = await res.json();
      if (Array.isArray(data)) setApis(data);
    } catch (err) {
      console.error("API fetch error:", err);
    }
  };

  useEffect(() => {
    fetchProviders();
    fetchApis();
  }, []);

  const showToast = (message, type = "success") => {
    toastr.options = {
      closeButton: true,
      progressBar: true,
      positionClass: "toast-top-right",
      timeOut: "3000",
    };

    if (type === "success") toastr.success(message);
    else if (type === "info") toastr.info(message);
    else toastr.error(message);
  };

  const handleCreateOrUpdateProvider = async () => {
    if (!ProviderForm.name.trim()) {
      showToast("Provider name is required", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? "/api/v1/provider/update"
      : "/api/v1/provider/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
        body: JSON.stringify({
          ...ProviderForm,
          id: editingId,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Something went wrong");

      showToast(editingId ? "Provider updated" : "Provider created", editingId ? "info" : "success");

      setProviderForm({
        name: "",
        plan: "",
        operatorfind: "",
        api_id: "",
        type: "",
        status: "active",
        min_amount: "",
        max_amount: ""
      });
      setEditingId(null);
      fetchProviders();
      document.querySelector("#exampleModal .btn-close").click();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (Provider) => {
    setProviderForm({
      name: Provider.name || "",
      plan: Provider.plan || "",
      operatorfind: Provider.operatorfind || "",
      api_id: Provider.api_id || "",
      type: Provider.type || "",
      status: Provider.status || "active",
      min_amount: Provider.min_amount || "",
      max_amount: Provider.max_amount || ""
    });
    setEditingId(Provider.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Provider?")) return;

    try {
      // const res = await fetch(`http://127.0.0.1:6060/api/v1/provider/delete/${id}`, {
       const res = await authFetch(`/api/v1/provider/delete/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("Provider deleted", "error");
      fetchProviders();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  const handleChange = (e) => {
    setProviderForm({ ...ProviderForm, [e.target.name]: e.target.value });
  };

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">
              <div className="card-title d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Provider Manager</h4>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setProviderForm({
                      name: "",
                      plan: "",
                      operatorfind: "",
                      api_id: "",
                      type: "",
                      status: "active",
                      min_amount: "",
                      max_amount: ""
                    });
                    setEditingId(null);
                  }}
                >
                  Add 
                </button>
              </div>

              {/* Modal */}
              <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{editingId ? "Edit Provider" : "Add Provider"}</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <label className="form-label">Provider Name</label>
                        <input
                        name="name"
                        placeholder="Provider Name"
                        className="form-control mb-2"
                        value={ProviderForm.name}
                        onChange={handleChange}
                        />

                        <label className="form-label">Plan</label>
                        <input
                        name="plan"
                        placeholder="Plan"
                        className="form-control mb-2"
                        value={ProviderForm.plan}
                        onChange={handleChange}
                        />

                        <label className="form-label">Operator Find</label>
                        <input
                        name="operatorfind"
                        placeholder="Operator Find"
                        className="form-control mb-2"
                        value={ProviderForm.operatorfind}
                        onChange={handleChange}
                        />

                        <label className="form-label">Min Amount</label>
                        <input
                          name="min_amount"
                          type="number"
                          placeholder="Minimum Amount"
                          className="form-control mb-2"
                          value={ProviderForm.min_amount}
                          onChange={handleChange}
                        />

                        <label className="form-label">Max Amount</label>
                        <input
                          name="max_amount"
                          type="number"
                          placeholder="Maximum Amount"
                          className="form-control mb-2"
                          value={ProviderForm.max_amount}
                          onChange={handleChange}
                        />

                        <label className="form-label">API</label>
                        <select
                        name="api_id"
                        className="form-control mb-2"
                        value={ProviderForm.api_id}
                        onChange={handleChange}
                        >
                        <option value="">Select API</option>
                        {apis.map((api) => (
                            <option key={api.id} value={api.id}>
                            {api.name}
                            </option>
                        ))}
                        </select>

                        <label className="form-label">Type</label>
                        <input
                        name="type"
                        placeholder="Type"
                        className="form-control mb-2"
                        value={ProviderForm.type}
                        onChange={handleChange}
                        />

                        <label className="form-label">Status</label>
                        <select
                        name="status"
                        className="form-control"
                        value={ProviderForm.status}
                        onChange={handleChange}
                        >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        </select>

                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button className="btn btn-primary" onClick={handleCreateOrUpdateProvider} disabled={loading}>
                        {loading ? "Saving..." : editingId ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <hr />
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Plan</th>
                      <th>Operator</th>
                      <th>API ID</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Min</th>
                      <th>Max</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Providers.length === 0 && (
                      <tr>
                        <td colSpan="7" className="text-center">No Providers found</td>
                      </tr>
                    )}
                    {Providers.map((Provider,i) => (
                      <tr key={Provider.id}>
                        <td>{i + 1}</td> 
                        <td>{Provider.name}</td>
                        <td>{Provider.plan}</td>
                        <td>{Provider.operatorfind}</td>
                        <td>{apis.find(api => api.id === Provider.api_id)?.name || Provider.api_id}</td>
                        <td>{Provider.type}</td>
                        <td>{Provider.status}</td>
                        <td>{Provider.min_amount}</td>
                        <td>{Provider.max_amount}</td>
                        <td>
                          <button className="btn btn-sm btn-info me-2" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleEdit(Provider)}>
                            <span className="bx bx-edit"></span>
                          </button>
                          {/* <button className="btn btn-sm btn-danger" onClick={() => handleDelete(Provider.id)}>
                            <span className="bx bx-trash"></span>
                          </button> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Provider;
